import { proxy } from "valtio";

import { defaultState } from "./constants";
import type * as Types from "./types";

export const state = proxy<Types.State>(defaultState);
